import React from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';
import { string } from 'prop-types';

import { useTranslation } from 'react-i18next';
import useLocales from '../hooks/data/useLocales';

import useStrapiPageData from '../hooks/data/useStrapiPageData';
// import useWithGA from '../hooks/useWithGA';

import { Loader } from '../ui/atoms/loader/Loader';
import { ReviewFormContent } from '../ui/organisms/system/reviewFormContent/ReviewFormContent';

import { PAGE_LEGAL_PRIVACY, PAGE_LEGAL_TERMS } from '../constants/strapi';

const GET_PUBLIC_REVIEW_TEMPLATE = gql`
  query GetPublicReviewTemplate($category: String!, $locale: String!) {
    publicReviewTemplate(category: $category, locale: $locale) {
      id
      reviewQuestions {
        id
        type
        required
        text
        reviewAnswers {
          id
          text
        }
      }
    }
  }
`;

const SUBMIT_REVIEW_FORM = gql`
  mutation SubmitReviewForm(
    $reviewTemplateId: ID!
    $systemId: String
    $sessionId: String
    $category: String
    $url: String
    $referrer: String
    $answers: Json
    $isLinkedIn: Boolean
  ) {
    submitReviewForm(
      reviewTemplateId: $reviewTemplateId
      systemId: $systemId
      sessionId: $sessionId
      category: $category
      url: $url
      referrer: $referrer
      answers: $answers
      isLinkedIn: $isLinkedIn
    )
  }
`;

const BusinesswithReviewForm = ({
  systemName,
  systemId,
  category,
  closeModal,
}) => {
  // const { handleDataLayer } = useWithGA();
  const { locale } = useLocales();
  const { t } = useTranslation();

  const [legalPrivacyPageUrl] = useStrapiPageData(PAGE_LEGAL_PRIVACY);
  const [legalTermsPageUrl] = useStrapiPageData(PAGE_LEGAL_TERMS);

  const { data, loading: publicReviewTemplateLoading } = useQuery(
    GET_PUBLIC_REVIEW_TEMPLATE,
    {
      fetchPolicy: 'cache-first',
      skip: !locale || !category,
      variables: {
        locale,
        category,
      },
    }
  );

  // TODO Handle error / console log or so
  const [
    submitReviewFormMutation,
    { data: submitReviewFormData, loading: submitReviewFormLoading },
  ] = useMutation(SUBMIT_REVIEW_FORM, {
    onError: (error) => {
      console.log(error);
    },
  });

  const reviewTemplateId = data?.publicReviewTemplate?.id;
  const reviewQuestions = data?.publicReviewTemplate?.reviewQuestions || [];
  const reviewSubmitted = submitReviewFormData?.submitReviewForm;

  const saveReview = async (answers, isLinkedIn = false) => {
    const { referrer } = window.frames.top.document;

    const { data } = await submitReviewFormMutation({
      variables: {
        reviewTemplateId,
        systemId,
        sessionId: sessionStorage.getItem('sessionId') || null,
        category,
        url: window.location.href,
        referrer,
        answers,
        isLinkedIn,
      },
    });

    return data?.submitReviewForm;
  };

  if (!reviewQuestions || publicReviewTemplateLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <Loader />
      </div>
    );
  }

  return (
    <ReviewFormContent
      questions={reviewQuestions}
      systemName={systemName}
      handleSubmit={saveReview}
      loading={submitReviewFormLoading}
      saved={reviewSubmitted}
      onClose={closeModal}
      urls={{
        legalPrivacyPageUrl,
        legalTermsPageUrl,
      }}
      t={t}
    />
  );
};

BusinesswithReviewForm.displayName = 'BusinesswithReviewForm';

BusinesswithReviewForm.propTypes = {
  systemName: string.isRequired,
  systemId: string.isRequired,
  category: string.isRequired,
};

export default BusinesswithReviewForm;
